import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { settingsStoreToken } from '../../../../../../../cross-team-shared/state/setting-state';
import { SettingsService } from '../../../../../../h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { pointCloudProjectionIcon } from '../../../../../../shared/icons/toolbars/point-cloud-projection-icon';

@Component({
  selector: 'h3-toggle-point-cloud-projection-button',
  templateUrl: './toggle-point-cloud-projection-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TogglePointCloudProjectionButtonComponent {
  private readonly settingsStore = inject(settingsStoreToken);

  areProjectionsEnabled$ = this.settingsStore('areProjectionsEnabled').$;
  showCloudProjection$ = this.settingsStore('showCloudProjection').$;
  pointCloudProjectionIcon = pointCloudProjectionIcon;

  private settingsService = inject(SettingsService);

  toggleProjection() {
    this.settingsService.toggleShowCloudProjection();
  }
}
